import classNames from 'classnames/bind';

import styles from './About.module.scss';
import Image from '~/components/Image';
import images from '~/assets/images';

const cx = classNames.bind(styles);

function About() {
    return (
        <div className={cx('wrapper')} id="about">
            <div className={cx('grid', 'wide')}>
                <div className={cx('inner', 'row')}>
                    <div className={cx('left', 'col', 'p-6', 't-12', 'm-12')}>
                        <div className={cx('left-body')}>
                            <Image src={images.personal} alt="MyPicture" className={cx('image')} />
                        </div>
                    </div>
                    <div className={cx('right', 'col', 'p-6', 't-12', 'm-12')}>
                        <div className={cx('right-header')}>
                            <h1>GIỚI THIỆU</h1>
                            <ul>
                                <li>
                                    <p style={{ display: 'none' }}>
                                        I am a passionate individual always ready to execute my ideas. I believe
                                        persistence is the key element in achieving success. My initial experiences have
                                        helped me to determine the right direction and develop the necessary skills to
                                        pursue a career in my field
                                    </p>
                                </li>
                                <li>
                                    <p>
                                        Tên đầy đủ của mình là Bùi Sỹ Ngọc Anh, sinh năm 2001, sinh ra và lớn lên tại Hà
                                        Tĩnh. Hiện tại mình đang là sinh viên năm 4, trường Đại học Bách Khoa Thành phố
                                        Hồ Chí Minh, chuyên ngành Điện tử - Viễn thông.
                                    </p>
                                </li>
                                <li>
                                    <p>
                                        Mình thích làm việc và mày mò với các thiết bị phần cứng, nhưng so với máy tính,
                                        công nghệ thông tin và lập trình thì mình lại thích việc lập trình hơn. Chính vì
                                        vậy nên mình quyết định gác lại sở thích phần cứng để theo đuổi đam mê này...
                                    </p>
                                </li>
                                <li>
                                    <p>
                                        Sau khoảng thời gian tự học, đặc biệt là học tập khóa học Front-end trên F8,
                                        mình đã xây dựng được một số kiến thức nền tảng và nâng cao cho công việc lập
                                        trình, đặc biệt hứng thú với việc phân tích UI/UX website và logic xử lý trong
                                        các nút bấm!
                                    </p>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default About;
